import { createSlice } from "@reduxjs/toolkit";
import getSuperadminDetailsApi from "@custom/rtk-apis/masterSuperAdminProfile/getSuperadminDetails";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const getSuperadminDetailsSlice = createSlice({
  name: "getSuperadminDetailsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSuperadminDetailsApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(getSuperadminDetailsApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getSuperadminDetailsApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getSuperadminDetailsSlice.reducer;
